import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import Container, { FlexSpaceBetweenContainer } from '@/components/container/Container';
import PasswordInput from '@/components/form-inputs/PasswordInput';
import { TextHeadlineLarge } from '@/components/text/Texts';
import { NEXT } from '@/constants/button-labels';
import { CREATE_USERNAME_AND_PASSWORD_FORM } from '@/constants/forms';
import IdGeneratorService from '@/services/id-generator.service';
import type { FormProps } from '@/types';
import { NextButton } from '@/components/buttons/Buttons';
import { type CreateUsernameAndPasswordFormData, defaultValues, schema } from '../../engine/create-username-and-password.model';
import { InputController } from '@/components/inputs/InputController';
import TextInput from '@/components/inputs/TextInput';

const CreateUsernameAndPasswordForm: React.FC<FormProps<CreateUsernameAndPasswordFormData>> = ({ isLoading, onSubmit, onBack }) => {
	const form = useForm({
		defaultValues,
		resolver: yupResolver(schema),
		mode: "all"
	});

	return (
		<form
			id={new IdGeneratorService(CREATE_USERNAME_AND_PASSWORD_FORM).formId}
			onSubmit={form.handleSubmit(onSubmit)}
			noValidate
		>
			<Container>
				<TextHeadlineLarge
					text="Create User name & Password"
					className="text-inverseSurface"
				/>
				<Container className="grid grid-cols-1 gap-4 pt-8">
					<InputController id="username" control={form.control}>
						<TextInput label="Username" />
					</InputController>
					<PasswordInput
						className="password-form-input"
						control={form.control}
						feedback
						formName={CREATE_USERNAME_AND_PASSWORD_FORM}
						id="password"
						label="Password"
					/>
					<PasswordInput
						className="password-form-input"
						control={form.control}
						formName={CREATE_USERNAME_AND_PASSWORD_FORM}
						id="confirmPassword"
						label="Confirm Password"
						placeholder=""
						needValidIcon
					/>
				</Container>
			</Container>

			<Container className="pt-[24px]">
				<FlexSpaceBetweenContainer>
					{/* <BackButton id="sign-up-back-button" onClick={onBack} /> */}
					<NextButton
						id="sign-up-next-button"
						className={`w-full ${!form.formState.isDirty ? 'disabled-button' : 'enabled-button'}`}
						disabled={!form.formState.isValid || isLoading}
						label={NEXT}
						type="submit"
						withIcon={false}
					/>
				</FlexSpaceBetweenContainer>
			</Container>
		</form>
	);
};

export default CreateUsernameAndPasswordForm;
